export const translateLangCodeToModuleName = (langCode) =>
  (langCode === "en") ? "en-GB"
  : (!langCode) ? "en-GB"
  : (langCode === "mn") ? "en-GB"
  : langCode;
